<template>
  <Modal
    :value="visible"
    title="增加出口"
    footer-hide
    width="50%"
  >
    <Form :model="formData" ref="form" :label-width="100" :rules="ruleValidate">
      <FormItem label="出口名称" prop="name">
        <Input v-model="formData.name" placeholder="" />
      </FormItem>
      <form-item-conditions v-model="formData.conditions" :formItemProps="{ prop: 'conditions' }"/>
      <form-item-tag :formItemProps="{ prop: 'tag' }" v-model="formData.tag"/>
      <form-item-var :formItemProps="{ prop: 'vars' }" v-model="formData.vars"/>
      <div class="flex flex-end">
        <Button style="margin-right: 20px" @click="cancel"
          >取消</Button
        >
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import FormItemConditions from './FormItemConditions.vue';
import cloneDeep from 'lodash/cloneDeep'
import FormItemTag from './FormItemTag.vue';
import FormItemVar from './FormItemVar.vue';

export default {
  components: { FormItemConditions, FormItemTag, FormItemVar },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ignore: {
      type: Array,
      default: () => [],
    },
    curOut: {
      type: Object,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        conditions: [],
        tag: '',
        vars: [],
      },
      ruleValidate: {
        name: [
          { required: true, message: '出口名称不能为空', trigger: 'blur' },
        ],
        conditions: [
          { required: true, message: '条件不能为空' },
        ],
      }
    }
  },
  watch: {
    curOut(val) {
      if (!val) return;
      this.formData = cloneDeep(val);
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$emit("editOut", this.formData);
        this.cancel();
      });
    },
    cancel() {
      this.formData = {
        name: '',
        conditions: [],
        tag: '',
        vars: [],
      }
      this.$emit('change', false)
    },
  }
};
</script>

<style lang="scss" scoped>
.formgroup{
	padding: 10px 0;
}
</style>
